import React from "react";
import { Link } from "react-router-dom";

const PhoneExistsMessage = () => (
    <>
        Este número de teléfono ya está registrado. Inicia sesión{" "}
        <Link to="/login" style={{ textDecoration: "underline" }}>
            aquí
        </Link>
    </>
);

export default PhoneExistsMessage;